// frontend/src/pages/Admin/Plans.jsx
import { useState, useEffect } from 'react';
import { getAdminPlans } from '../../api/services';

export default function AdminPlans() {
    const [plans, setPlans] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchPlans();
    }, []);

    const fetchPlans = async () => {
        try {
            // The axios client attaches the token and, via its response
            // interceptor, handles a 401 on protected endpoints. We just
            // request the data and render it.
            const { data } = await getAdminPlans();
            setPlans(Array.isArray(data) ? data : []);
        } catch (err) {
            console.error('Failed to fetch plans:', err);
            setError(err?.response?.data?.detail || 'Failed to fetch plans.');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-[400px]">
                <svg className="animate-spin h-10 w-10 text-brand-amber" viewBox="0 0 24 24" fill="none">
                    <circle className="opacity-20" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" />
                    <path className="opacity-80" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
                </svg>
            </div>
        );
    }

    if (error) {
        return (
            <div className="card border-red-500/30 bg-red-500/5 text-red-400 font-body">
                Error: {error}
            </div>
        );
    }

    return (
        <div>
            <div className="flex items-center justify-between mb-6">
                <h1 className="font-display text-2xl font-bold text-brand-text">Plans</h1>
                <span className="text-xs text-brand-muted font-body border border-brand-border rounded-full px-3 py-1">
                    Read-only · editing in M5
                </span>
            </div>

            <div className="card p-0 overflow-hidden">
                <table className="min-w-full">
                    <thead>
                        <tr className="border-b border-brand-border">
                            <th className="px-6 py-3 text-left text-xs font-medium text-brand-muted uppercase tracking-widest font-body">Name</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-brand-muted uppercase tracking-widest font-body">Display Name</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-brand-muted uppercase tracking-widest font-body">Monthly Cap</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-brand-muted uppercase tracking-widest font-body">Price</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-brand-muted uppercase tracking-widest font-body">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {plans.map((plan) => (
                            <tr key={plan.id} className="border-b border-brand-border last:border-0 hover:bg-brand-surface/50 transition-colors">
                                <td className="px-6 py-4 text-sm font-medium text-brand-text font-body capitalize">{plan.name}</td>
                                <td className="px-6 py-4 text-sm text-brand-text font-body">{plan.display_name}</td>
                                <td className="px-6 py-4 text-sm text-brand-text font-body">{plan.monthly_cap}</td>
                                <td className="px-6 py-4 text-sm text-brand-text font-body">£{(plan.price_pence / 100).toFixed(2)}</td>
                                <td className="px-6 py-4">
                                    <span className={`px-2.5 py-1 text-xs rounded-full font-body ${plan.is_active ? 'bg-green-500/10 text-green-400' : 'bg-red-500/10 text-red-400'}`}>
                                        {plan.is_active ? 'Active' : 'Inactive'}
                                    </span>
                                </td>
                            </tr>
                        ))}
                        {plans.length === 0 && (
                            <tr>
                                <td colSpan={5} className="px-6 py-10 text-center text-brand-muted font-body text-sm">
                                    No plans found.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}